export default __webpack_public_path__ + "static/media/tourism.99cf9fb9.gif";